module.exports = __webpack_public_path__ + "img/jiaoyu_wuyi_suoluetu.f7cc54e7.png";